
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class extends Vue {
  join1ImgUrl: string = require("@/assets/images/common/link/link_join1.jpg");
  join2ImgUrl: string = require("@/assets/images/common/link/link_join2.jpg");
  join3ImgUrl: string = require("@/assets/images/common/link/link_join3.jpg");
}
